<template>
  <div>
    <h2 class="mb-3">
      {{ 'Kiểm hàng thực tế' }}
    </h2>
    <ReceivedDeliveryTable
      :headers="headers"
      :items="items"
      :inventories="inventories"
      :actualTotalQuantity="actualTotalQuantity"
      :remainQuantity="remainQuantity"
      :totalQuantity="totalQuantity"
      :totalCount="totalCount"
      :loading="loading"
      @onRefresh="onRefresh"
    />
    <PopupEditInventory ref="inventory-dialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { get, isEmpty } from 'lodash'
import PopupEditInventory from './PopupEditInventory.vue'
import ReceivedDeliveryTable from '../../modules/deliveryManagement/ReceivedDeliveryTable/index.vue'
export default {
  components: {
    PopupEditInventory,
    ReceivedDeliveryTable
  },
  data() {
    return {
      stats: {},
      importOrderInventory: {},
      totalCount: 0,
      headers: [],
      items: [],
      inventories: [],
      totalQuantity: 0,
      actualTotalQuantity: 0,
      remainQuantity: 0,
      loading: false
    }
  },
  computed: {
    ...mapState({
      importDelivery(state) {
        return state['importDeliveries'].item
      }
    }),
    importOrder() {
      return this.importDelivery.importOrder
    }
  },
  methods: {
    ...mapActions({
      getStatsImportOrderModels: 'importDeliveries/getStatsImportOrderModels',
      fetchImportOrderInventory: 'importDeliveries/fetchImportOrderInventory',
      countImportOrderModels: 'importDeliveries/countImportOrderModels'
    }),
    handleHeader(importOrder) {
      let inventories = get(importOrder, 'data.inventories', {})
      let i = []
      const invLength = 82
      let headers = [
        { text: 'Model', value: 'code', width: '120px', align: 'left' },
        { text: 'Mô tả', value: 'description', width: '150px', align: 'left' },
        { text: 'SL nhập', value: 'quantity', width: `${invLength}px`, align: 'end' }
      ]
      inventories = Object.values(inventories)
      inventories.forEach(inventory => {
        i.push({
          text: inventory.name_short,
          value: inventory.name_short,
          width: `${invLength}px`,
          align: 'end'
        })
      })
      headers.push(...i)
      headers.push({ text: 'SL đã giao', value: 'delivered', width: `90px`, align: 'end' })
      headers.push({ text: 'SL còn lại', value: 'remaining', width: `90px`, align: 'end' })
      this.headers = headers
    },
    handleItems(data) {
      data.forEach(i => i.inventories)
      const mapData = data.map(product => {
        const handle = {}
        const quantity = get(product, 'quantity', 0)
        product.inventories.forEach(inventory => {
          const quantity = get(inventory, 'quantity', 0)
          const actualQuantity = get(inventory, 'actualQuantity', 0)
          handle[inventory.name_short] = {
            data: `${actualQuantity}/${quantity}`,
            isLack: actualQuantity < quantity || false
          }
        })
        const delivered = product.inventories.reduce(
          (accumulator, currentValue) => accumulator + get(currentValue, 'actualQuantity', 0),
          0
        )
        return {
          code: product.code,
          description: product.description,
          quantity,
          delivered,
          remaining: quantity - delivered,
          ...handle
        }
      })
      this.items = mapData
    },
    handleQuantityByInventory(inventories = {}, quantityByInventory = {}) {
      if (isEmpty(inventories) || isEmpty(quantityByInventory)) return
      let result = {}
      for (const inventoryId in inventories) {
        if (inventories.hasOwnProperty(inventoryId)) {
          const inventoryData = inventories[inventoryId]
          const quantityData = quantityByInventory[inventoryId] || {}

          result[inventoryId] = {
            name: inventoryData.name,
            name_short: inventoryData.name_short,
            quantity: quantityData.quantity || 0,
            actualQuantity: quantityData.actualQuantity || 0
          }
        }
      }
      result = Object.values(result)
      this.inventories = result
    },
    handleDataTable() {
      const importOrder = this.importDelivery.importOrder
      const quantity = this.stats
      let data = this.importOrderInventory
      this.totalQuantity = get(quantity, 'totalQuantity', 0)
      this.actualTotalQuantity = get(quantity, 'actualTotalQuantity', 0)
      this.remainQuantity = this.totalQuantity - this.actualTotalQuantity
      this.handleHeader(importOrder)
      if (this.headers) this.handleItems(data)
      this.handleQuantityByInventory(get(importOrder, 'data.inventories', {}), quantity.quantityByInventory)
    },
    async onRefresh(params) {
      this.loading = true
      try {
        this.importOrderInventory = await this.fetchImportOrderInventory({
          id: get(this.importOrder, 'id', ''),
          params: { ...params, _stat: true }
        })
        this.stats = await this.getStatsImportOrderModels({
          type: 'check',
          id: get(this.importOrder, 'id', ''),
          params: {
            code_constants: params.code_constants,
            description_contains: params.description_contains
          }
        })
        this.totalCount = await this.countImportOrderModels({
          importOrder: get(this.importOrder, 'id', ''),
          code_constants: params.code_constants,
          description_contains: params.description_contains
        })
        this.handleDataTable()
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    try {
      this.loading = true
      const importOrderId = get(this.importOrder, 'id')
      if (importOrderId) {
        const importOrderInventory = await this.fetchImportOrderInventory({
          id: importOrderId,
          params: { _stat: true, _start: 0, _limit: 10 }
        })
        const statsImportOrder = await this.getStatsImportOrderModels({
          type: 'check',
          id: get(this.importOrder, 'id', '')
        })
        const countImportOrderModels = await this.countImportOrderModels({
          importOrder: get(this.importOrder, 'id', '')
        })
        this.totalCount = countImportOrderModels
        this.stats = statsImportOrder
        this.importOrderInventory = importOrderInventory
        this.handleDataTable()
      }
    } catch (error) {
    } finally {
      this.loading = false
    }
  }
}
</script>
